import PropTypes from 'prop-types';
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  makeStyles
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import User from '~/modules/common/components/User/User';

const useLabelStyles = makeStyles(theme => ({
  label: {
    whiteSpace: 'nowrap',
    paddingLeft: '5px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: 800,
    fontSize: theme.typography.body2.fontSize
  }
}));

const useClasses = makeStyles(theme => ({
  text: {
    marginLeft: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(0.25)
  },
  content: {
    display: 'flex'
  },
  roleText: {
    marginLeft: theme.spacing(0.25)
  }
}));
const ResourceMergeDialog = ({
  closeResourceMergeDialog,
  resourceMergeDialogOpen,
  resourceMergeDialogAllocation,
  onConfirm
}) => {
  const classes = useClasses();

  const { user, role } = resourceMergeDialogAllocation;
  const roleText = role?.displayText || '';

  const { formatMessage } = useIntl();
  const labelClasses = useLabelStyles();

  return (
    <Dialog
      open={resourceMergeDialogOpen}
      onClose={closeResourceMergeDialog}
      aria-labelledby="resource-merge-dialog-title"
      aria-describedby="resource-merge-dialog-description"
    >
      <DialogTitle id="resource-merge-dialog-title">
        {formatMessage({ id: 'resourceMergeDialog.mergeAllocations' })}
      </DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          <User classes={labelClasses} user={user} />
          <Typography
            variant="body2"
            color="textPrimary"
            className={classes.text}
          >
            {formatMessage(
              {
                id: roleText
                  ? 'resourceMergeDialog.mergeContentWithRole'
                  : 'resourceMergeDialog.mergeContentWithoutRole'
              },
              {
                role: (
                  <strong key={roleText} className={classes.roleText}>
                    {roleText}
                  </strong>
                )
              }
            )}
          </Typography>
        </div>
        <Typography variant="body2" color="textSecondary">
          {formatMessage({
            id: 'resourceMergeDialog.mergeContentDescription'
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          data-qe-id="CancelDialogButton"
          onClick={closeResourceMergeDialog}
        >
          {formatMessage({ id: 'resourceMergeDialog.cancel' })}
        </Button>
        <Button
          data-qe-id="ConfirmDialogButton"
          color="primary"
          onClick={onConfirm}
          autoFocus
        >
          {formatMessage({ id: 'resourceMergeDialog.mergeAllocations' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ResourceMergeDialog.propTypes = {
  resourceMergeDialogOpen: PropTypes.bool.isRequired,
  closeResourceMergeDialog: PropTypes.func.isRequired,
  resourceMergeDialogAllocation: PropTypes.object,
  onConfirm: PropTypes.func.isRequired
};

export default ResourceMergeDialog;
